import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/sys' : '/sys'
export function getListpage(obj) {
  return request({
    url:urlPrefix+ '/parameter/listpage',
    method: 'post',
    data: obj
  })
}
export function delParameterById(id) {
    return request({

      url: urlPrefix+'/parameter/' + id,
      method: 'delete'
  })
}

export function addParameter(obj) {
    return request({
      url: urlPrefix+'/parameter',
      method: 'post',
      data: obj
    })
}

export function updateParameter(obj) {
  return request({
    url:urlPrefix+ '/parameter',
    method: 'put',
    data: obj
  })
}
export function checkParaKeyIsExists(paraKey,tabType) {
  return request ({
  //  url: urlPrefix+'/parameter/parakeyisexists/' + paraKey + '/' + id,
   url: urlPrefix+'/parameter/paramKeyExists',
   method: 'get',
   params: {
     paraKey: paraKey,
     tabType: tabType
    }
  })
}
export function getValueSelects(type){
  return request ({
    url: urlPrefix+'/parameter/paramList',
    method: 'get',
    params: {
      paramType: type
    }
  })
}
export function initParameter() {
  return request({
    url:urlPrefix+ 'init/cache/parameter',
    method: 'get'
  })
}
